'use client'

import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react'
import { IoHomeOutline, IoRefreshOutline } from "react-icons/io5"
import { Link } from 'react-router-dom'
export default function BadRequestPage() {
  const bgColor = useColorModeValue('gray.50', 'gray.900')
  const textColor = useColorModeValue('gray.600', 'gray.300')

  return (
    <Box bg={bgColor} minH="100vh" py={10}>
      <Container maxW="container.md">
        <VStack spacing={8} align="center" textAlign="center">
          <Heading size="4xl" color="orange.500">
            400
          </Heading>
          <Heading size="xl">Peticion fallida</Heading>
          <Text fontSize="xl" color={textColor}>
            Lo sentimos, parece que algo no funcionó como se esperaba
          </Text>
          <Box>
            <Link to="/">
              <Button leftIcon={<IoHomeOutline />} colorScheme="teal" size="lg" mr={4}>
                Volver al inicio
              </Button>
            </Link>
            <Button leftIcon={<IoRefreshOutline />} colorScheme="blue" size="lg" onClick={() => window.location.reload()}>
              Reintentar
            </Button>
          </Box>
        </VStack>
      </Container>
    </Box>
  )
}